import { ENVIORNMENTS } from "utils/constants";
import styles from "./styles.module.scss";

export const Tabs = ({ activeTab, setActiveTab, tabsArr, handleClick }) => {
  function handleClickTab(tab) {
    setActiveTab(tab.key);
    sessionStorage.setItem(ENVIORNMENTS.ENVIORNMENT, tab.key);
    handleClick(tab.key);
  }

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {tabsArr.map((tab) => (
          <div
            className={`
  ${styles[tab.key === activeTab ? "activeSingleTab" : "singleTab"]}
  
`}
            key={tab.key}
            onClick={() => handleClickTab(tab)}
          >
            <tab.icon
              color={tab.key === activeTab ? tab?.activeColor : tab?.color}
              height={18}
              width={18}
            />
            <div className={styles.label}>{tab.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
